<template>
  <el-form ref="form" label-position="top" :model="form" :rules="rules" label-width="120px" class="app-container view-container">
    <BjDivider>
      {{ $t('AddingAnInternalReturnRefundDoc.Basic') }}
      <template slot="right">
        <el-button @click="cancel()">{{ $t('backText') }}</el-button>
        </template>
    </BjDivider>
    <template>
      <el-row>
      <div class="bj-row mt10 mb10">
      <div class="bj-col-11">
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessAfterCsgReturn.main.totalQty') }}</div>
          <div class="bj-form-item-value">{{ form.planQty }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('ReturnOrderText') }}{{ $t('goodsBrand.page.Status') }}</div>
          <div class="bj-form-item-value">{{ $t(RETURN_ORDER_STATUS.bjGet(form.status)) }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessAfterCsgReturn.main.backInventoryQty') }}</div>
          <div class="bj-form-item-value">{{ form.backInventoryQty }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessAfterCsgReturn.main.backInventoryRemark') }}</div>
          <div class="bj-form-item-value">
            <BjTextarea v-model="form.backInventoryRemark" disabled />
          </div>
        </div>
      </div>
      <div class="bj-col-1"></div>
      <div class="bj-col-12">
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrderDetail.table.associatedCode') }}</div>
          <div class="bj-form-item-value">{{ form.thirdCode }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessAfterCsgReturn.table.reference') }}</div>
          <div class="bj-form-item-value">{{ form.remark }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessAfterCsgReturn.main.damagedQty') }}</div>
          <div class="bj-form-item-value">{{ form.damagedQty }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessAfterCsgReturn.main.damagedRemark') }}</div>
          <div class="bj-form-item-value">
            <BjTextarea v-model="form.damagedRemark" disabled />
          </div>
        </div>
      </div>
    </div>
    <BjDivider>
      {{ $t('BusinessPurchaseComponentsPur.information') }}
    </BjDivider>
    <el-table :data="[form]" border script max-height="600">
      <el-table-column :label="$t('BjDialogListConfig.SKUcode')" prop="standardSkuCode" align="center"></el-table-column>
      <el-table-column :label="$t('BjDialogListConfig.SKUname')" prop="skuName" align="center"></el-table-column>
      <el-table-column :label="$t('BusinessAfterCsgReturn.main.totalQty')" prop="planQty" align="center"></el-table-column>
      <el-table-column :label="$t('BusinessAfterCsgReturn.table.backInventoryQty')" prop="backInventoryQty" align="center"></el-table-column>
      <el-table-column :label="$t('BusinessAfterCsgReturn.table.backInventoryRemark')" prop="backInventoryRemark" align="center"></el-table-column>
      <el-table-column :label="$t('BusinessAfterCsgReturn.table.damagedQty')" prop="damagedQty" align="center"></el-table-column>
      <el-table-column :label="$t('BusinessAfterCsgReturn.table.damagedRemark')" prop="damagedRemark" align="center"></el-table-column>
    </el-table>
    </el-row>
  </template>

  <BjDivider>{{ $t('BusinessAfterCsgReturn.pictureMsg') }}</BjDivider>
    <div class="mt20">
      <div class="flex">
        <div v-for="(imageUrl, index) in form.thirdPartyReturnOrderMaterialList" :key="index" class="imageViewer">
          <BjKeyImage
            height="148px"
            width="148px"
            :url="normalizeDownloadUrl(imageUrl.detailImage)"
            style="margin: 10px"
            preview
          />
          <div class="flex flex-spacearound">
            <i class="el-icon-download yellow" @click="downloadImage(imageUrl.detailImage)"></i>
            <i v-if="!$store.getters.cusId" class="el-icon-delete red" @click="deleteImage(imageUrl.detailImage)"></i>
          </div>
        </div>
      </div>
    </div>
    <template v-if="!$store.getters.cusId">
      <el-row>
        <BjDivider>{{ $t('InternalReturnRefundNoteDetails.Upload') }}{{ $t('AddingAnInternalReturnRefundDoc.Picture') }}</BjDivider>
        <div class="mt20">
          <el-form-item label="" style="display: block; height: 100%">
            <BjUpload
              ref="BjUpload"
              class="avatar-uploader"
              :limit="20"
              :limit-size="5 * 1024"
              multiple
              show-file-list
              list-type="picture-card"
              accept="image/png,image/jpeg"
              :accept-list="['image/jpeg', 'image/png']"
              auto-upload
              limit-hide
              @afterUpload="afterUpload"
              @remove="onRemoveUrl"
            >
              <template slot="default">
                <i class="el-icon-plus avatar-uploader-icon" />
              </template>
              <template slot="tip">
                <!-- 支持上传多附件，非必填 -->
                <!-- 可拖拽图片调整顺序,支持上传文件格式、尺寸根据各平台与定，大小不超过5M -->
              </template>
            </BjUpload>
          </el-form-item>
        </div>
        <el-col :span="colSpan">
          <el-form-item label="Comment">
            <BjTextarea v-model="comment" :maxlength="999" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div class="text-center mt20 mb20">
          <el-button style="width: 150px" @click="cancel()">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" style="width: 150px" @click="onConfirm">{{ $t('okText') }}</el-button>
        </div>
      </el-row>
    </template>
  </el-form>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { thirdReturnApi } from '@/api';
import BjUpload from '@/components/BjUpload/index';
import { RETURN_ORDER_STATUS } from '@/utils/constants';
export default {
name: 'BusinessAfterCsgAdminReturnView',
components: {
  BjUpload,
},
mixins: [viewMiXin],
data() {
  return {
    RETURN_ORDER_STATUS,
    colSpan: 12,
    form: {},
    updateImages: [],
    comment: null,
    rules: {},
  };
},
computed: {},
mounted() {
  this.getData();
},
methods: {
  // 删除图片
  deleteImage(file) {
    this.$confirm(this.$t('InternalSalesOrderDetails.want')).then(() => {
      this.form.thirdPartyReturnOrderMaterialList.splice(
        this.form.thirdPartyReturnOrderMaterialList.findIndex(e => e.detailImage === file),
        1,
      );
      this.form.thirdPartyReturnOrderMaterialList = this.form.thirdPartyReturnOrderMaterialList.map(item => {
        return {detailImage: item.detailImage};
      });
      setTimeout(() => {
        this.editApi(this.form);
      }, 300);
    }).catch(_ => {});
},
  // 截取下载的图片名
  imageFileName(url) {
    const urlObj = new URL(url);
    // 获取路径名部分（包括查询参数和哈希值之前的部分）
    const pathname = urlObj.pathname;
    // 使用最后一个'/'字符将路径名分割成目录和文件名两部分
    const parts = pathname.split('/');
    // 提取出文件名
    const fileName = parts.pop();
    // 如果文件名包含查询参数或哈希值，使用'?'或'#'字符将其分割出来
    const fileNameWithoutQueryOrHash = fileName.split('?')[0].split('#')[0];
    return fileNameWithoutQueryOrHash;
  },
  // 下载图片
  downloadImage(url) {
    if (!url) return;
    url = this.normalizeDownloadUrl(url);
    const fileName = this.imageFileName(url);
    this.downloadImageUrl(url, fileName);
  },
  // 获取 上传的 新数据 并 合并到旧数据
  afterUpload(url) {
    this.updateImages.push({detailImage: url});
  },
  onRemoveUrl(file) {
    this.updateImages.splice(
        this.updateImages.findIndex(e => e.detailImage === file.url),
        1,
      );
  },
  /** 确定 */
  onConfirm() {
    if (this.updateImages.length) {
      this.form.thirdPartyReturnOrderMaterialList = this.form.thirdPartyReturnOrderMaterialList.map(item => {
        return {detailImage: item.detailImage};
      });
        this.updateImages.forEach(item => this.form.thirdPartyReturnOrderMaterialList.push(item));
      }
    this.form.comment = this.comment;
    this.editApi(this.form);
  },

  editApi(API_DATA) {
    delete API_DATA.createdBy;
    delete API_DATA.lastUpdatedBy;
    thirdReturnApi.editThirdPartyReturnOrder(API_DATA).then(res => {
      if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
        this.$message.success(this.$t('toast.operationSuccessText'));
        setTimeout(() => {
          this.getData();
          this.$refs.BjUpload.fileList = [];
          this.updateImages = [];
          this.comment = null;
        }, 500);
      }
    });
  },
  getData() {
    thirdReturnApi.detailThirdPartyReturnOrder({orderId: this.$route.query.id}).then(res => {
      this.form = res;
    });
  }
},
};
</script>
<style lang="scss" scoped>
.app-container {

  .imageViewer {
    display: flex;
    flex-direction: column;
    align-items: center;

    .red {
      color: red;
      cursor: pointer;
    }
    .yellow {
      color: #ff8f40;
      cursor: pointer;
      font-size: 18px;
    }
  }
}

</style>
